import { computed, defineComponent } from 'vue';
import { useViewStore } from 'src/stores/view';
import { layoutIntPlugin } from 'src/plugins/i18n/local/layouts';
import genericOptions from "src/layouts/standard/components/navOptions/components/genericOptions.vue";
/**
 * Standard way of displaying drawer options in app
 */
export default defineComponent({
    components: {
        genericOptions,
    },
    props: {
        appDrawerOption: {
            type: Array,
            required: true,
        },
        iconRight: Boolean,
        iconSize: {
            type: String,
            default: "1.1rem",
        },
        isOuter: Boolean
    },
    setup(props) {
        const { t } = layoutIntPlugin();
        const computedDrawerOptions = computed(() => props.appDrawerOption);
        const viewStore = useViewStore();
        /**
         * Custom routing
         */
        function customRoute(title) {
            if (title === t('host.Booking Calendar')) {
                viewStore.toggleShowCalendar(true);
            }
        }
        return {
            computedDrawerOptions,
            customRoute
        };
    }
});
